module.exports = __webpack_public_path__ + "img/960.e6d31f66.svg";